// -------------------- //
// ------- TNEW ------- //
// -------------------- //

window.addEventListener('DOMContentLoaded', function () {
    // Adding a <span> tag after radio button and
    // checkbox input fields for styling purposes

    let radioBtnContainers = document.querySelectorAll('.radio');
    let checkboxContainers = document.querySelectorAll('.checkbox');
    let contributionDropDown = document.querySelector('#AddContribution_ContributionTypeId') as HTMLSelectElement;
    let removeCartItem = document.querySelector('.tn-cart__btn-remove');

    let mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            checkboxContainers = Array.prototype.slice.call(document.querySelectorAll('.checkbox'));

            if (checkboxContainers != null && checkboxContainers.length > 0) {
                injectSpanElement(checkboxContainers);
            }
        });
    });

    if (radioBtnContainers != null) {
        injectSpanElement(radioBtnContainers);
    }
    if (checkboxContainers != null) {
        injectSpanElement(checkboxContainers);
    }

    // Mutation observer will only run on donation pages with dynamic content
    // or pages with dynamic modals
    if (contributionDropDown) {
        contributionDropDown.addEventListener('change', function () {
            mutationObserver.observe(document.documentElement, {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true,
                attributeOldValue: true,
                characterDataOldValue: true
            });
        });
    }

    if (removeCartItem) {
        removeCartItem.addEventListener('click', function () {
            mutationObserver.observe(document.documentElement, {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true,
                attributeOldValue: true,
                characterDataOldValue: true
            });
        });
    }
});

function injectSpanElement(nodeList) {
    if (nodeList) {
        let containersArray = Array.prototype.slice.call(nodeList);

        containersArray.forEach(function (item) {
            if (!item.querySelector('.faux-label')) {
                let label = item.querySelector('label');
                let fauxLabel = document.createElement('span');

                fauxLabel.classList.add('faux-label');

                while (label.lastChild && label.lastChild.nodeType === 3) {
                    fauxLabel.appendChild(label.lastChild);
                }

                label.appendChild(fauxLabel);
            }
        });
    }
}

// ----- TNEW V6 ----- //

//I know. I'm sorry. I had to do it!

//removing annoying inline important styles from cart table headers
//Remove inline, important properties from cart headers and fix underscore in title

var thereIsACart = false;

var tinyCartHeaders = Array.prototype.slice.call(
    document.querySelectorAll('#cartTable > tbody > tr > td > table > tbody > tr > td > table > tbody > tr > td')
);
if (tinyCartHeaders.length < 1) {
    tinyCartHeaders = Array.prototype.slice.call(
        document.querySelectorAll('.TNEW_page_block > table > tbody > tr > td > table > tbody > tr > td')
    );
}
if (tinyCartHeaders.length < 1) {
    tinyCartHeaders = Array.prototype.slice.call(document.querySelectorAll('.tn-cart .tn-hide > td'));
}
tinyCartHeaders.forEach(function (header) {
    header.style.fontSize = '';
    header.style.backgroundColor = '';
    if (header.textContent.indexOf('_') > 0) {
        header.innerHTML = header.innerHTML.split('_').join(' ');
    }
});

if (tinyCartHeaders.length > 0) thereIsACart = true;

//Add proper spacing and remove random periods from navigation
var mainNav = document.querySelector('.login-link-container');
if (mainNav) {
    mainNav.innerHTML = mainNav.innerHTML.replace(/&nbsp;.&nbsp;&nbsp;/g, '');
    var nodes = Array.prototype.slice.call(mainNav.childNodes);
    mainNav.innerHTML = '';
    nodes.forEach(function (node) {
        if (node.nodeType == Node.TEXT_NODE) {
            if (node.textContent.trim().length > 0) {
                var newSpan = document.createElement('span');
                newSpan.innerHTML = node.textContent;
                mainNav.appendChild(newSpan);
            }
        } else {
            mainNav.appendChild(node);
        }
    });
}

//Separate cart item titles into <p> tags instead of <br> delineated
if (thereIsACart) {
    var titles = Array.prototype.slice.call(
        document.querySelectorAll(
            '#cartTable table[cellpadding="4"] > tbody > tr:first-child ~ tr > td:first-child, .TNEW_page_block table[cellpadding="4"] > tbody > tr:first-child ~ tr > td:first-child'
        )
    );
    titles.forEach(function (title) {
        var newtitle = title.innerHTML;
        newtitle = '<p>' + newtitle.split('<br>').join('</p><p>') + '</p>';
        title.innerHTML = newtitle;
    });
}

//Permanent fix for the TNEW seatmap responsive issue

//INITIALIZE WHEN #screen-selector LOADS

// var container = document.querySelector('#screen-selector');
// var imageMaps,
//     checkForImageMapLoad = false;

// if (container) {
//     setupInterval();
// }

// function setupInterval() {
//     document.removeEventListener('click', setupInterval);
//     if (!checkForImageMapLoad) {
//         checkForImageMapLoad = setInterval(function() {
//             if (container.offsetWidth > 0) {
//                 //check when SYOS is loaded by the container being set to block
//                 clearInterval(checkForImageMapLoad);
//                 checkForImageMapLoad = false;
//                 loadMaps();
//             }
//         }, 500);
//     }
// }

// function loadMaps() {
//     imageMaps = document.querySelectorAll('img[usemap]');
//     if (imageMaps.length > 0) {
//         fixImageMaps();
//         window.onresize = fixImageMaps;
//         document.body.addEventListener('click', setupInterval);
//     }
// }

// function fixImageMaps() {
//     [].forEach.call(imageMaps, function(img) {
//         if (!img.naturalHeight) {
//             return;
//         }
//         var h = img.height / img.naturalHeight;
//         var w = img.width / img.naturalWidth;
//         var map = document.getElementsByName(img.useMap.slice(1))[0];
//         if (!map) {
//             return;
//         }
//         for (var i = 0; i < map.children.length; i++) {
//             var area = map.children[i];
//             if (!area.coords) {
//                 continue;
//             }
//             var coords = area.coords;
//             if (!area.originalCoords) {
//                 area.originalCoords = coords;
//             } else {
//                 coords = area.originalCoords;
//             }
//             var split = coords.split(',');
//             var fixed = '';
//             split.forEach(function(coord, n) {
//                 if (n != 0) {
//                     fixed += ',';
//                 }
//                 fixed += n % 2 == 0 ? Number(coord) * w : Number(coord) * h;
//             });
//             area.coords = fixed;
//         }
//     });
// }



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/tnew/javascript/tnew.ts